module.exports = __webpack_public_path__ + "img/particle-wide-band.29980b15.png";